var Component = require("enyo/Component"),
    kind      = require("enyo/kind"),
    logger    = require("enyo/logger"),
    throttle  = require("enyo-perf/utils").throttle;

module.exports = kind(/** @lends  app.MediaPlayer.ProgressTrackers.VideoProgressTracker.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.ProgressTrackers.VideoProgressTracker",

    /**
     * @private
     */
    kind: Component,

    /**
     * The video player.
     *
     * @type  {app.MediaPlayer.Tech.Astract.AbstractVideoPlayer}
     * @private
     */
    playerTech: null,

    /**
     * Whether we're actively tracking the player.
     *
     * @type  {boolean}
     * @private
     */
    isTracking: false,

    /**
     * The interval between pings while the player is playing. Time set in
     * milliseconds.
     *
     * @public
     */
    pingInterval: 10000,

    /**
     * The maximum frequency of pings. Prevents flooding the backend with pings.
     * Time set in milliseconds.
     *
     * @public
     */
    pingThrottle: 250,

    /**
     * Reference to the interval that checks for time updates.
     *
     * @type {timeoutID}
     * @private
     */
    _pingTimeoutId: null,

    /**
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.ping = throttle(this.bindSafely(this.ping), 250);
            this.observe("playerTech.isPlaying", this.maybeToggleTracking);
            this.observe("playerTech.cursor", this.maybeToggleTracking);
        };
    }),

    /**
     * Handle changes in the player state.
     *
     * @private
     */
    maybeToggleTracking: function() {
        var $playerTech = this.playerTech;

        // If player is playing and a cursor value is available, we can start
        // tracking.
        if ($playerTech.get("isPlaying") && $playerTech.get("cursor") !== null) {
            !this.isTracking && this.startTracking();
        }

        // If the player is not playing or it doesn't have a cursor value, we
        // stop tracking.
        else {
            this.isTracking && this.stopTracking();
        }
    },

    /**
     * Start tracking player progress.
     *
     * @private
     */
    startTracking: function() {
        if (!this.isTracking) {
            this.set("isTracking", true);
            this.ping();
        }
    },

    /**
     * Submit playback progress.
     *
     * @private
     */
    ping: function() {
        var $watchingSessionService = this.app.$.watchingSessionService,
            $playerTech             = this.playerTech,
            cursor                  = $playerTech ? $playerTech.get("cursor") : null;

        if (!$playerTech
            || $watchingSessionService.hasSession !== 1
            || !$watchingSessionService.hasPingEndpoint()) {
            this.stopTracking();

            return;
        }

        if (cursor || cursor === 0) {
            // Reset timer
            this._pingTimeoutId && clearTimeout(this._pingTimeoutId);

            $watchingSessionService.updateCursor(cursor)
                .then(this.bindSafely(function(response) {
                    if (response.status === "ok") {
                        // Schedule next ping
                        if (this.isTracking) {
                            this._pingTimeoutId = setTimeout(this.ping, this.pingInterval);
                        }
                    }
                    else if (response.status === "canceled") {
                        // No-op
                    }
                    else {
                        this.controller.triggerHandler("onProgressTrackerError", {
                            type: response.type
                        });
                    }
                }))
                .catch(this.bindSafely(function(error) {
                    logger.error(error);

                    if (typeof Sentry !== "undefined" && error instanceof Error) {
                        Sentry.captureException(error);
                    }

                    this.controller.triggerHandler("onProgressTrackerError", {
                        type:    "progress_tracker_error",
                        message: error
                    });
                }));
        }
    },

    /**
     * Start tracking player progress.
     *
     * @private
     */
    stopTracking: function() {
        if (this.isTracking) {
            this._pingTimeoutId && clearTimeout(this._pingTimeoutId);
            this.set("isTracking", false);
            this.ping();
        }
    },

    /**
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.stopTracking();
            sup.apply(this, arguments);
        };
    })

});
